import type { Editor } from "@tiptap/react"
import { pick } from "../../../filestack/api"
import { MEDIA_TYPES } from "../../../filestack/constants"
import type { PickerFileMetadata } from "../../../filestack/types"
import { getOptions } from "../../../filestack/utils"
import type { RichTextEditorPickedMedia } from "../../types"
import type { EditorChain } from "../types"

export function insertImageFromMedia(
  editor: Editor,
  file: RichTextEditorPickedMedia,
  chain: (e: Editor) => EditorChain
) {
  if (!file?.url) return
  chain(editor)
    .focus()
    .setImage({
      src: file.url,
      alt: file.filename || file.name || "Image"
    })
    .run()
}

export async function pickAndInsertImageFromFilestack(
  editor: Editor,
  insert: (file: RichTextEditorPickedMedia) => void
) {
  try {
    const result = await pick(
      getOptions(MEDIA_TYPES.IMAGE, {
        maxFiles: 1
      })
    )
    ;(result.filesUploaded || []).forEach((file: PickerFileMetadata) => {
      insert(file)
    })
  } catch (error) {
    console.error("Error inserting inline image from Filestack:", error)
  }
}
